import * as Yup from "yup";
import IntlMessages from "components/Utils/intlMessages";

export const LoginSchema = Yup.object().shape({
  mobile: Yup.number()
    .typeError(<IntlMessages id="global.onlyNumber" />)
    .required(<IntlMessages id="global.required" />),
});
